<template>
    <div>
      这是测试

    </div>

</template>

<script>
    export default {
        name: "Test",
      data(){
          return {
            str:'',
          }
      },

      mounted() {
        let fruits=["Banana","Orange","Apple","Mango","Banana","Orange","Apple"]
        let a = fruits.indexOf("Apple22")
        console.log(123, a)
      }


    }
</script>

<style scoped>
  .second{
    margin-left: 1rem;
  }

  .third{
    margin-left: 2rem;
  }

</style>
